<kendo-label text="Load Status">
    <kendo-multiselect [data]="loadedStatuses"
                       [disabled]="isDisabled"
                       [value]="value"
                       (valueChange)="handleValueChange($event)"
                       (blur)="handleBlur()"
                       textField="name"
                       valueField="value"
                       [valuePrimitive]="true">
    </kendo-multiselect>
</kendo-label>
